import { render, staticRenderFns } from "./PositionAdjust.vue?vue&type=template&id=e861857a&scoped=true&"
import script from "./PositionAdjust.vue?vue&type=script&lang=js&"
export * from "./PositionAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e861857a",
  null
  
)

export default component.exports